import { render, staticRenderFns } from "./Comorbidities.vue?vue&type=template&id=d27b016c&scoped=true&"
import script from "./Comorbidities.vue?vue&type=script&lang=js&"
export * from "./Comorbidities.vue?vue&type=script&lang=js&"
import style0 from "./Comorbidities.vue?vue&type=style&index=0&id=d27b016c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27b016c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VForm,VIcon,VSpacer,VTextField})
